import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import {
    useGetPortalProjectQuery,
    useUpdateStageStatusMutation,
} from '../../redux/api/compassPortal';
import { useGetIfUserIsAdminQuery } from '../../redux/api/user';
import StatusSelector from './StatusSelector';

const stageMeta = {
    'data-validation': {
        title: 'Data Validation',
        description: 'Processed data is rigorously checked for accuracy, consistency, and completeness.',
    },
    'data-modelling': {
        title: 'Data Modelling',
        description: 'Our team builds and calibrates the Compass model using your validated data.',
    },
    'compass-delivery': {
        title: 'Compass Delivery',
        description: 'The finalised Compass model and outputs are delivered and walked through with your team.',
    },
};

const StagePage = ({ stageId }) => {
    const { projectId } = useParams();
    const navigate = useNavigate();

    const { data: project, isLoading } = useGetPortalProjectQuery({ projectId });
    const { data: isAdmin } = useGetIfUserIsAdminQuery();
    const [updateStageStatus] = useUpdateStageStatusMutation();

    const meta = stageMeta[stageId];
    const stage = project?.stages?.find((s) => s.id === stageId);

    const handleStatusChange = async (status) => {
        await updateStageStatus({ projectId, stage_id: stageId, status }).unwrap();
    };

    const today = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

    if (isLoading) {
        return <div style={{ width: '100%', textAlign: 'center', padding: '80px 0' }}><Spin size="large" /></div>;
    }
    if (!project || !meta) return null;

    return (
        <div style={{ width: '100%' }}>
            <button className="cp-back-link" onClick={() => navigate(`/compass-portal/${projectId}`)}>
                &larr; Back to timeline
            </button>

            <div className="cp-stage-header">
                <div className="cp-stage-header__left">
                    <h2>{meta.title}</h2>
                </div>
                <div className="cp-stage-header__center">
                    <div className="cp-stage-header__dateline">
                        <span className="cp-stage-header__dateline-label">DEADLINE</span>
                        <span className="cp-stage-header__dateline-value">{stage?.due_date || '—'}</span>
                    </div>
                    <div className="cp-stage-header__dateline cp-stage-header__dateline--today">
                        <span className="cp-stage-header__dateline-label">TODAY</span>
                        <span className="cp-stage-header__dateline-value">{today}</span>
                    </div>
                </div>
                {isAdmin && (
                    <StatusSelector
                        currentStatus={stage?.status}
                        onChange={handleStatusChange}
                    />
                )}
            </div>

            <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--medium-light-grey-color)', fontSize: 14, maxWidth: 600, margin: '0 auto' }}>
                {meta.description}
            </div>
        </div>
    );
};

export default StagePage;
